module.exports = __webpack_public_path__ + "5b71e9110834c41b8837c6fd4dc85cee.svg";